import type { CrmTranslate } from './crm-copy';

export function createCrmShellCopy(t: CrmTranslate) {
  return {
    app: {
      shortName: t('crm.app.shortName'),
      bugReporterAppName: 'TopoloCRM',
      bugReporterAppVersion: '1.0.0',
    },
    navSections: {
      overview: t('crm.navSections.overview'),
      sharedCore: t('crm.navSections.sharedCore'),
      sharedWorkflows: t('crm.navSections.sharedWorkflows'),
      realEstate: t('crm.navSections.realEstate'),
    },
    navSectionDescriptions: {
      overview: t('crm.navSectionDescriptions.overview'),
      sharedCore: t('crm.navSectionDescriptions.sharedCore'),
      sharedWorkflows: t('crm.navSectionDescriptions.sharedWorkflows'),
      realEstate: t('crm.navSectionDescriptions.realEstate'),
    },
    nav: {
      dashboard: t('crm.nav.dashboard'),
      contacts: t('crm.nav.contacts'),
      companies: t('crm.nav.companies'),
      deals: t('crm.nav.deals'),
      pipelines: t('crm.nav.pipelines'),
      tasks: t('crm.nav.tasks'),
      inbox: t('crm.nav.inbox'),
      portals: t('crm.nav.portals'),
      portalLeads: t('crm.nav.portalLeads'),
      settings: t('crm.nav.settings'),
      import: t('crm.nav.import'),
      workspace: t('crm.nav.workspace'),
      gettingStarted: t('crm.nav.gettingStarted'),
      apiKeys: t('crm.nav.apiKeys'),
    },
    command: {
      navigation: t('crm.command.navigation'),
      create: t('crm.command.create'),
      open: t('crm.command.open'),
      openItem: (name: string) =>
        t('crm.command.openItem', {
          values: { name },
        }),
      placeholder: t('crm.command.placeholder'),
      createContactTitle: t('crm.command.createContactTitle'),
      createContactSubtitle: t('crm.command.createContactSubtitle'),
      createCompanyTitle: t('crm.command.createCompanyTitle'),
      createCompanySubtitle: t('crm.command.createCompanySubtitle'),
      createDealTitle: t('crm.command.createDealTitle'),
      createDealSubtitle: t('crm.command.createDealSubtitle'),
      createContactKeywords: [
        t('crm.command.createContactKeywords.0'),
        t('crm.command.createContactKeywords.1'),
        t('crm.command.createContactKeywords.2'),
        t('crm.command.createContactKeywords.3'),
      ],
      createCompanyKeywords: [
        t('crm.command.createCompanyKeywords.0'),
        t('crm.command.createCompanyKeywords.1'),
        t('crm.command.createCompanyKeywords.2'),
        t('crm.command.createCompanyKeywords.3'),
      ],
      createDealKeywords: [
        t('crm.command.createDealKeywords.0'),
        t('crm.command.createDealKeywords.1'),
        t('crm.command.createDealKeywords.2'),
        t('crm.command.createDealKeywords.3'),
      ],
    },
    accountMenu: {
      crmSettings: t('crm.accountMenu.crmSettings'),
      gettingStartedDescription: t('crm.accountMenu.gettingStartedDescription'),
    },
    workspace: {
      label: t('crm.workspace.label'),
      create: t('crm.workspace.create'),
      createPrompt: t('crm.workspace.createPrompt'),
    },
    tour: {
      addContactsTitle: t('crm.tour.addContactsTitle'),
      addContactsContent: t('crm.tour.addContactsContent'),
      trackDealsTitle: t('crm.tour.trackDealsTitle'),
      trackDealsContent: t('crm.tour.trackDealsContent'),
    },
  };
}
